module.exports = __webpack_public_path__ + "ollie_office-cddc9ef6.webp";